import { render, staticRenderFns } from "./ExpensesTotals.vue?vue&type=template&id=1a715d59&scoped=true"
import script from "./ExpensesTotals.vue?vue&type=script&lang=js"
export * from "./ExpensesTotals.vue?vue&type=script&lang=js"
import style0 from "./ExpensesTotals.vue?vue&type=style&index=0&id=1a715d59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a715d59",
  null
  
)

export default component.exports